import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterTreatmentRecordContextMenuProps {
  canDelete: boolean;
  id: string;
  isDeleting: boolean;
  label: string;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  status?: string | null;
  trigger: ReactNode;
}

export const MatterTreatmentRecordContextMenu = ({
  canDelete,
  id,
  isDeleting,
  label,
  matter,
  onDelete,
  onEdit,
  status,
  trigger,
}: MatterTreatmentRecordContextMenuProps) => (
  <MatterSubItemContextMenu
    createSignatureRequest
    copyValue={[label, status ? `Status: ${status}` : undefined]
      .filter(Boolean)
      .join("\n")}
    delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
    entityLabel={label}
    entityName="treatment record"
    matter={matter}
    onEdit={onEdit}
    subItem={{ id, type: "medical-treatment-record" }}
    trigger={trigger}
  />
);
